import { useDispatch, useSelector } from "react-redux";
import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";

import { Icon } from "../../icon/Icon";
import { openMoveModal } from "../devices.actions";
import { LazyLoadDropdownItem } from "@sportal/cdk/dropdown/LazyLoadDropdownItem";
import { DeviceActionsModalItem } from "../DeviceActionsDialog";
import { isAssignActionDisabled } from "../../../store/profiles/profiles.selectors";

export const useMoveDeviceMenuItem = (deviceName) => {
  const dispatch = useDispatch();
  const isDisabled = useSelector(isAssignActionDisabled);

  return {
    id: "move",
    content: (
      <Fragment>
        <Icon icon="fa-regular fa-plus" />
        <span>
          <FormattedMessage id="assign_to_group" />
        </span>
      </Fragment>
    ),
    action: () => dispatch(openMoveModal(deviceName)),
    disabled: isDisabled,
  };
};

export const MoveDeviceDropdownItem = ({ deviceName, ...props }) => {
  const { id, content, action, disabled } = useMoveDeviceMenuItem(deviceName);

  return (
    <LazyLoadDropdownItem
      id={id}
      action={action}
      {...props}
      disabled={disabled}
    >
      {content}
    </LazyLoadDropdownItem>
  );
};

export const MoveDeviceModalItem = ({ deviceName }) => {
  const { id, content, action, disabled } = useMoveDeviceMenuItem(deviceName);

  return (
    <DeviceActionsModalItem id={id} action={action} disabled={disabled}>
      {content}
    </DeviceActionsModalItem>
  );
};
